import { IconButton, Stack, Typography, useTheme } from '@mui/material';
import { ELinks } from '@sharedInterfaces/globalEnums';
import { ArrowLeft, ChevronRight, Home } from 'lucide-react';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface IMvpBreadcrumbProps {
    currentPageTitle?: string;
}

function MvpBreadcrumb({ currentPageTitle }: IMvpBreadcrumbProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();

    const pathnames = location.pathname.split('/').filter((x) => x);
    const subPath = pathnames.length > 1 ? pathnames[pathnames.length - 1] : null;

    return (
        <Stack direction="row" spacing={0.5} alignItems="center">
            <IconButton
                size="small"
                onClick={() => navigate(`/${ELinks.DASHBOARD}`)}
                sx={{
                    color: 'text.secondary',
                    '&:hover': {
                        color: 'text.primary',
                        bgcolor: 'action.hover',
                    },
                }}
            >
                <Home size={18} />
            </IconButton>

            <IconButton
                size="small"
                onClick={() => navigate(-1)}
                sx={{
                    color: 'text.secondary',
                    '&:hover': {
                        color: 'text.primary',
                        bgcolor: 'action.hover',
                    },
                }}
            >
                <ArrowLeft size={18} />
            </IconButton>

            {currentPageTitle && (
                <>
                    <Typography color="text.disabled" sx={{ fontSize: '0.875rem', ml: 0.5, mr: 2 }}>
                        |
                    </Typography>

                    <Typography variant="body2" fontWeight={500}>
                        {currentPageTitle}
                    </Typography>
                </>
            )}
        </Stack>
    );
}

export default MvpBreadcrumb;
